/* VOLUFILINE — Formula tabs (sections/vf-tabs). ARIA tabs (arrow keys, Home/End, automatic
   activation), crossfading media per tab, inline muted how-to clip (loads on first play,
   pauses when its tab is left), optional tap-for-sound. Re-inits on theme-editor section load. */
(function () {
  if (window.VfTabs) return;

  function init(root) {
    if (!root || root.__vfTabs) return;
    root.__vfTabs = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    var media = Array.prototype.slice.call(root.querySelectorAll('[data-vf-tabs-media]'));
    var vfig = root.querySelector('.vf-tabs__fig--video');
    var video = vfig && vfig.querySelector('video');
    var playBtn = vfig && vfig.querySelector('[data-vf-tabs-play]');
    var soundBtn = vfig && vfig.querySelector('[data-vf-tabs-sound]');
    var current = 0;

    function setInert(el, on) {
      if (!el) return;
      if (on) { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); }
      else { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); }
    }

    function select(i, focus) {
      if (i === current && !focus) return;
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[n]) { panels[n].classList.toggle('is-active', on); if (on) panels[n].removeAttribute('inert'); else panels[n].setAttribute('inert', ''); }
      });
      media.forEach(function (m) {
        var on = Number(m.getAttribute('data-vf-tabs-media')) === i;
        m.classList.toggle('is-active', on);
        setInert(m, !on);
      });
      if (focus) tabs[i].focus();
      if (video && media[2] && i !== 2 && !video.paused) pause();
      current = i;
    }

    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { select(n); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, to = null, last = tabs.length - 1;
        if (k === 'ArrowRight' || k === 'ArrowDown') to = n === last ? 0 : n + 1;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') to = n === 0 ? last : n - 1;
        else if (k === 'Home') to = 0;
        else if (k === 'End') to = last;
        if (to === null) return;
        e.preventDefault();
        select(to, true);
      });
    });

    /* ---- video ---- */
    function hasAudio(v) {
      return !!(v.mozHasAudio || (typeof v.webkitAudioDecodedByteCount === 'number' && v.webkitAudioDecodedByteCount > 0) || (v.audioTracks && v.audioTracks.length));
    }
    function pause() {
      video.pause();
      vfig.classList.add('is-paused');
      playBtn.setAttribute('aria-pressed', 'false');
    }
    function play() {
      if (!video.getAttribute('src') && video.dataset.src) { video.src = video.dataset.src; video.preload = 'auto'; }
      video.muted = !(soundBtn && soundBtn.getAttribute('aria-pressed') === 'true');
      var p = video.play();
      vfig.classList.add('is-playing');
      vfig.classList.remove('is-paused');
      playBtn.setAttribute('aria-pressed', 'true');
      if (soundBtn) soundBtn.hidden = false;
      if (p && p.catch) p.catch(function () { pause(); });
      if (!vfig.__tracked) {
        vfig.__tracked = true;
        try {
          (window.dataLayer = window.dataLayer || []).push({ event: 'volufiline_video_play', placement: 'formula', video_id: 'howto' });
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('volufiline_video_play', { placement: 'formula', video_id: 'howto' });
        } catch (err) {}
      }
    }
    if (video && playBtn) {
      playBtn.addEventListener('click', function () {
        if (video.paused) play(); else pause();
      });
      video.addEventListener('ended', pause);
      if (soundBtn) {
        var lbl = soundBtn.querySelector('[data-vf-tabs-sound-label]');
        /* hide the sound button when the browser can tell the clip has no audio track */
        video.addEventListener('playing', function () {
          setTimeout(function () {
            var canTell = ('mozHasAudio' in video) || ('webkitAudioDecodedByteCount' in video) || !!video.audioTracks;
            if (canTell && !hasAudio(video)) soundBtn.hidden = true;
          }, 900);
        });
        soundBtn.addEventListener('click', function () {
          var on = soundBtn.getAttribute('aria-pressed') !== 'true';
          soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
          video.muted = !on;
          if (lbl) lbl.textContent = on ? lbl.getAttribute('data-on') : lbl.getAttribute('data-off');
          if (on && video.paused) play();
        });
      }
    }
  }

  function boot() { document.querySelectorAll('[data-vf-tabs]').forEach(init); }
  window.VfTabs = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-vf-tabs]'); if (r) init(r); });
})();
